// extracted by mini-css-extract-plugin
export default {"address":"editPrint_address__STBDz","formFields":"editPrint_formFields__9fW-O","corner_button":"editPrint_corner_button__Md1ax","display_text":"editPrint_display_text__Yi1M7"};